import LogoCenter from 'assets/logo-center.svg?react';
import LogoInnerRing from 'assets/logo-inner-ring.svg?react';
import LogoOuterRing from 'assets/logo-outer-ring.svg?react';

import './sonevo-loader.scss';

export enum LoadingIndicatorStyle {
  colored,
  white,
}

type Props = {
  readonly size?: number;
  readonly style?: LoadingIndicatorStyle;
};

const SonevoLoadingIndicator = ({ size, style }: Readonly<Props>): React.JSX.Element => (
  <>
    <LogoCenter
      className={style === LoadingIndicatorStyle.white ? 'sonevo-loader white' : undefined}
      height={size}
      width={size}
      fill={style === LoadingIndicatorStyle.white ? 'white' : undefined}
      style={{ position: 'absolute' }}
    />
    <LogoInnerRing
      className={style === LoadingIndicatorStyle.white ? 'sonevo-loader white' : undefined}
      height={size}
      width={size}
      style={{
        position: 'absolute',
        animation: 'spin 1s linear infinite',
      }}
    />
    <LogoOuterRing
      className={style === LoadingIndicatorStyle.white ? 'sonevo-loader white' : undefined}
      height={size}
      width={size}
      style={{
        position: 'absolute',
        animation: 'spin 1s linear infinite reverse',
      }}
    />
  </>
);

export default SonevoLoadingIndicator;
